import { loginBaseUrl } from 'constants/lead_form_utils';
import trackSignInClicked from 'packages/signup/analytics/trackSignInClicked';
import { isPartnersInvitePage } from 'helpers/visitor_page_helper';
import useResponsive from 'packages/signup/helpers/useResponsive';
import trackingEvents from 'helpers/trackingEvent';

const LearnHowWorksLinkText = 'Learn how Gusto works';

const AlreadyWithGusto = () => (
  <div className="footer-links text-align-center">
    Already use Gusto?{' '}
    <a onClick={trackSignInClicked} href={loginBaseUrl} className="account-creation-sign-in-cta">
      Sign in here
    </a>
    .
  </div>
);

const EmployeeOrContractorAccount = () => (
  <div className="text-align-center footer-links">
    Trying to create an employee or contractor account?{' '}
    <a
      onClick={() => {
        trackingEvents('Button', 'Click', 'navigate to support article', 'Let us help');
      }}
      href="https://support.gusto.com/article/104263831100000/Sign-in-to-Gusto"
      className="account-creation-ee-contractor-cta"
    >
      Let us help
    </a>
    .
  </div>
);

const LearningJourney = () => {
  const queryString = window.location.search;
  const urlParams = window.location.search ? `?${new URLSearchParams(queryString)}` : '';
  const url = `/invite/company/explore${urlParams}`;

  return (
    <div className="margin-bottom-15px lp-footer-signin text-align-center">
      Not ready to run payroll yet? <br />
      <a
        onClick={() => {
          trackingEvents('Button', 'Click', 'navigate to explore page', LearnHowWorksLinkText);
        }}
        href={url}
        className="account-creation-how-gusto-works-cta"
      >
        {LearnHowWorksLinkText}
      </a>
      .
    </div>
  );
};

const renderMobileFooter = () => (
  <>
    <AlreadyWithGusto />
    <LearningJourney />
    <EmployeeOrContractorAccount />
  </>
);

const renderDesktopFooter = () => (
  <>
    <AlreadyWithGusto />
    <EmployeeOrContractorAccount />
  </>
);

export default function FormFooter() {
  const { isMobile } = useResponsive();

  const getFooterContent = () => {
    return isMobile ? renderMobileFooter() : renderDesktopFooter();
  };

  const footerClassName = isPartnersInvitePage() ? 'sign-up-footer' : '';

  return <div className={footerClassName}>{getFooterContent()}</div>;
}
